import * as React from "react";
import Image from "../../../ui/widgets/image";
import Button from "../../../ui/widgets/button";
import uploadErrorImage from "../../../resources/images/scd-upload-error.svg";
import { useMessageSource } from "react-message-source";
import Typography from "../../../ui/widgets/typography";
import { MouseEventHandler } from "react";

interface ErrorUploaderProps {
  handleOnClickFileUploader?: MouseEventHandler;
  isDropActive: boolean;
  error: string;
}

const classNameBase = "scd-upload";

const ErrorUploader = ({
  handleOnClickFileUploader,
  isDropActive,
  error,
}: ErrorUploaderProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();
  return (
    <>
      <div className={`${classNameBase}-image`}>
        <Image src={uploadErrorImage} />
      </div>
      <div className={`${classNameBase}-file-wrapper`}>
        <Button onClick={handleOnClickFileUploader} disabled={isDropActive}>
          {getMessage("Button.upload")}
        </Button>
        <Typography variant="body2" className={`${classNameBase}-error-text`}>
          {error}
        </Typography>
      </div>
    </>
  );
};

export default ErrorUploader;
